// extracted by mini-css-extract-plugin
export var postGrid = "q_bn";
export var wpPageLayout = "q_bm";
export var wpPageRelatedGrid = "q_bp";
export var wpPageRoot = "q_bl";